/**
 * 后端语言标识与前端 i18n 语言包 key 的映射
 * 后端接口返回的 lang 字段 -> 前端 i18n 使用的 locale key
 * 同时兼容 `xx_YY`、`xx-YY` 以及纯语言码
 */
export const LANG_MAP = {
  'zh-CN': 'zh',
  'en-US': 'en',
  'ru-RU': 'ru'
}

/**
 * 根据后端语言标识获取 i18n locale key
 * 优先精确匹配，其次按语言前缀（zh_CN -> zh）匹配
 */
export function getI18nLocale(lang) {
  if (!lang) return 'zh'
  if (LANG_MAP[lang]) return LANG_MAP[lang]
  const prefix = String(lang).split(/[-_]/)[0]
  return LANG_MAP[prefix] || 'zh'
}

/**
 * 默认语言标识（后端标识格式）
 */
export const DEFAULT_LANG = 'en-US'
